module.exports = require("@mui/icons-material/FormatAlignJustify");